import AvertaRegularWOFF from "./Fonts/0305857a-9a8b-46ef-9487-5354e315c6b5.woff"
import AvertaRegularWOFF2 from "./Fonts/51f01bf8-c568-40b2-af85-6bff46971ecb.woff2"
import AvertaBoldWOFF from "./Fonts/889a7d86-12c6-408b-8c48-373a9e30545d.woff"
import AvertaBoldWOFF2 from "./Fonts/477f324e-236a-4290-81be-3dc6cd89aee5.woff2"
import AvertaBlackWOFF from "./Fonts/fc51127f-231a-46ef-9b37-939fd3d21dfa.woff2"
import AvertaBlackWOFF2 from "./Fonts/a62d1448-7e6b-4e3c-802a-79db9b5e2ddd.woff"

const FontsExport = {
    AvertaRegularWOFF,
    AvertaRegularWOFF2,
    AvertaBoldWOFF,
    AvertaBoldWOFF2,
    AvertaBlackWOFF,
    AvertaBlackWOFF2
}

export default FontsExport